import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';

const initialState = {
  isSet: false,
  isWaiting: false,
  totalCount: 0,
  currentPage: 1,
  isFinished: false,
  tracks: null
};

const favoritesStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  getFavorites: (sessionToken, pageSize) => {
    console.log("fav", pageSize)
    set({ currentPage: 1, tracks: null, isWaiting: true, isFinished: false });
    MuvikaService.getFavorites(sessionToken, 500, 1)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, tracks: null, totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let tracks = res.data.data.items;
          set({ isSet: true, tracks: tracks, totalCount: res.data.data.items_total, isWaiting: false });
          if (tracks.length < 500) {
            set({ isFinished: true });
          }
        }
      })
      .catch(function () { });
  },
  getFavoritesMore: (sessionToken, pageSize) => {
    let page = get().currentPage + 1;
    set({ currentPage: page, isWaiting: true });
    MuvikaService.getFavorites(sessionToken, 500, page)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, tracks: null, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let tracks = get().tracks;
          let tracksMore = res.data.data.items;
          if (tracksMore.length == 0) {
            set({ isFinished: true });
          }
          tracks = tracks.concat(tracksMore);
          set({ isSet: true, tracks: tracks, totalCount: res.data.data.items_total, isWaiting: false });
        }
      })
      .catch(function () { });
  },
  setFavorite: (sessionToken, favTrack) => {
    MuvikaService.setFavorite(sessionToken, favTrack.track_id)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let tracks = get().tracks;
          if (!tracks) {
            tracks = [];
          }
          let trackIndex = tracks.findIndex(x => x.track_id == favTrack.track_id);
          if (trackIndex != -1) {
            tracks[trackIndex].is_favorite = 1;
            let tracksSorted = tracks.sort(function (a, b) {
              let textA = a.title;
              let textB = b.title;
              return textA.localeCompare(textB);
            });
            set({ tracks: [...tracksSorted], totalCount: get().totalCount + 1 });
          } else {
            favTrack.is_favorite = 1;
            tracks.push(favTrack);
            let tracksSorted = tracks.sort(function (a, b) {
              let textA = a.title;
              let textB = b.title;
              return textA.localeCompare(textB);
            });
            set({ tracks: [...tracksSorted], totalCount: get().totalCount + 1 });
          }
        }
      })
      .catch(function () { });
  },
  deleteFavorite: (sessionToken, favTrack) => {
    MuvikaService.deleteFavorite(sessionToken, favTrack.track_id)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let tracks = get().tracks;
          if (!tracks) {
            tracks = [];
          }
          let trackIndex = tracks.findIndex(x => x.track_id == favTrack.track_id);
          if (trackIndex != -1) {
            tracks[trackIndex].is_favorite = 0;
            var favs = tracks.filter((track) => track.is_favorite == 1);
            set({ tracks: [...tracks], totalCount: get().totalCount - 1 });
          } else {
            favTrack.is_favorite = 0;
            tracks.push(favTrack);
            var favs = tracks.filter((track) => track.is_favorite == 1);
            set({ tracks: [...tracks], totalCount: get().totalCount - 1 });
          }
        }
      })
      .catch(function () { });
  },
  setTrackRating: (sessionToken, favTrack, rating) => {
    MuvikaService.setTrackRating(sessionToken, favTrack.track_id, rating)
      .then(function (res) {
        if (res.data.error) {
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let tracks = get().tracks;
          if (!tracks) {
            tracks = [];
          }
          let trackIndex = tracks.findIndex(x => x.track_id == favTrack.track_id);
          if (trackIndex != -1) {
            tracks[trackIndex].rating = rating;
            set({ tracks: [...tracks] });
          } else {
            favTrack.rating = rating;
            tracks.push(favTrack);
            set({ tracks: [...tracks], totalCount: tracks.length });
          }
        }
      })
      .catch(function () { });
  }
}));

export default favoritesStore;